module.exports = __webpack_public_path__ + "static/media/negative.745442f5.svg";